export default __webpack_public_path__ + "static/media/notepad.0746dce5.png";